import React from "react";
import { ChevronLeft } from "lucide-react";
import { useSwipeToOpen } from "../../hooks/useSwipeToClose";
import { useMobileEdgeChromeSuppressed } from "../../stores/mobileEdgeChromeStore";
import {
  INSPECTOR_CHROME_HOVER_SURFACE,
  INSPECTOR_CHROME_NO_FOCUS_RING,
} from "../../utils/inspectorChromeButtonClasses";
import { InspectorIcon } from "../ui/Icons";
import { INSPECTOR_TITLE_TYPE_LABEL } from "./inspectorTargetUtils";

export default function InspectorMinimizedTab({
  activePanel,
  getPanelIcon,
  isMobile,
  minimized,
  panelMargin,
  setMinimized,
  tabAttentionAnimating,
  titleInfo,
}) {
  const mobileEdgeChromeSuppressed = useMobileEdgeChromeSuppressed();
  const inspectorTabSwipeToOpenHandlers = useSwipeToOpen({
    enabled: minimized && !!activePanel,
    onOpen: () => setMinimized(false),
  });
  const inspectorTabLabel = titleInfo?.type
    ? `Show ${INSPECTOR_TITLE_TYPE_LABEL[titleInfo.type] || titleInfo.type} properties`
    : "Show inspector";

  if (!minimized || (isMobile && mobileEdgeChromeSuppressed)) return null;

  const inspectorMinimizedTabIcon = (
    <span className="flex items-center justify-center text-gray-200 max-[720px]:min-w-0 max-[720px]:flex-1 max-[720px]:basis-0 max-[720px]:pl-1.5">
      <span className="flex h-4 w-4 items-center justify-center">
        {activePanel ? (
          getPanelIcon("w-4 h-4")
        ) : (
          <InspectorIcon className="h-4 w-4 flex-shrink-0 text-gray-200" />
        )}
      </span>
    </span>
  );
  const inspectorMinimizedTabChevron = (
    <span className="flex items-center justify-center max-[720px]:min-w-0 max-[720px]:flex-1 max-[720px]:basis-0 max-[720px]:px-2">
      <ChevronLeft
        className="inspector-minimized-tab-chevron h-3.5 w-3.5 max-[720px]:h-5 max-[720px]:w-5"
        strokeWidth={2.5}
      />
    </span>
  );

  return (
    <button
      type="button"
      onClick={() => setMinimized(false)}
      className={`inspector-minimized-tab${activePanel ? "" : " inspector-minimized-tab-empty"}${tabAttentionAnimating ? " inspector-minimized-tab--attention" : ""} fixed flex flex-row items-center justify-center gap-0.5 max-[720px]:justify-stretch max-[720px]:gap-0 rounded-l-md border border-r-0 border-gray-700 text-gray-300 hover:text-gray-100 transition-colors cursor-pointer ${INSPECTOR_CHROME_NO_FOCUS_RING} ${INSPECTOR_CHROME_HOVER_SURFACE}`}
      {...inspectorTabSwipeToOpenHandlers}
      style={{
        top: panelMargin,
        right: 0,
        width: "3rem",
        height: "2.5rem",
        backgroundColor: "var(--panel-surface)",
        zIndex: 200,
      }}
      aria-label={inspectorTabLabel}
      title={inspectorTabLabel}
    >
      {isMobile ? (
        <>
          {inspectorMinimizedTabIcon}
          {inspectorMinimizedTabChevron}
        </>
      ) : (
        <>
          {inspectorMinimizedTabChevron}
          {inspectorMinimizedTabIcon}
        </>
      )}
    </button>
  );
}
